import { check } from "./Can.utils";
var Can = function (props) {
    var _a, _b;
    return check(props.role, props.perform)
        ? ((_a = props.yes) === null || _a === void 0 ? void 0 : _a.call(props)) || null
        : ((_b = props.no) === null || _b === void 0 ? void 0 : _b.call(props)) || null;
};
export default Can;
